// Función para abrir la ventana de WhatsApp con el mensaje y número especificados
function enviarMensajeWhatsapp() {
  var mensaje = document.getElementById('message-area').value;
 /*var mensaje = encodeURIComponent('¿Cómo podemos ayudarlo en su pedido o consulta?');*/
 /*var numero = '+34684261544';*/
 /*var url = 'https://api.whatsapp.com/send?phone=' + numero + '&text=' + mensaje;*/
 var url = `https://wa.me/+34684261544?text=${encodeURIComponent(mensaje)}`;
 window.open(url, '_blank');
 
}

// Función para mostrar la tarjeta
function mostrarTarjeta() {
 document.getElementById('tarjeta').style.display = 'block';
 document.getElementById('abrirChatBtn').style.display = 'none'; // Oculta el botón "Abrir chat"
}

// Mostrar la tarjeta después de tres segundos
setTimeout(mostrarTarjeta, 50000);

// Asignar el evento click al botón de cerrar
document.getElementById('cerrarBtn').addEventListener('click', function() {
 document.getElementById('tarjeta').style.display = 'none';
 document.getElementById('abrirChatBtn').style.display = 'grid'; // Muestra el botón "Abrir chat"
});

// Asignar el evento click al botón de abrir WhatsApp
document.querySelector('.whatsapp-btn').addEventListener('click', enviarMensajeWhatsapp);

// Crear el botón "Abrir chat" y asignarle el evento click
var abrirChatBtn = document.createElement('div');
abrirChatBtn.innerHTML = '';
abrirChatBtn.classList.add('abrir-chat-btn');
abrirChatBtn.id = 'abrirChatBtn'; // Asigna un ID al botón
abrirChatBtn.addEventListener('click', mostrarTarjeta);
document.body.appendChild(abrirChatBtn);
